function StoreMediaKitPage() {
    return <p>Media Kit Page</p>
}

export default StoreMediaKitPage